
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tpm",
      function () {
        return require("private-next-pages/tpm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tpm"])
      });
    }
  